import React from 'react';
import NavigationBar from '../../components/navbar/component'
import Head from '../../components/head/component'
import Image from '../../image/OurTeamCover.png'
import {
    Footer
} from '../../components/footer/components'
import { Box } from 'reflexbox'
import Email from '../../image/email.png'
import Linkedin from '../../image/linkedin.png'
import { 
    Wrapper,
    NameDivBox,
    BodyBox,
    ImageDiv,
    WhiteCircle,
    YellowCircle,
    Section,
    Title,
    Description,
    SendEmailButton,
    LinkedinButton,
    ButtonContainer,
    BoxImage,
    BGColor
 } from './style'
import Profile1 from '../../image/profile1.png'
import Profile2 from '../../image/profile2.png'
import Profile3 from '../../image/profile3.png'
import Star from '../../image/Star.png'

const data = [
    {
        name: "AGUST SYAHPUTRA DOLOKSARIBU",
        title: "Managing Partner of Sequoia Advocates",
        description: "Agust is a dedicated legal professional with a strong background in [specific area of law, e.g., corporate law, criminal defense, family law, etc.]. With a passion for justice and over [number] years of experience. He excels in providing strategic counsel, advocating for clients' rights, and delivering successful outcomes in complex legal matters.",
        image: Profile1,
        bgColor: "#9A302C"
    },
    {
        name: "HISAR JOHANNES",
        title: "Partner of Sequoia Advocates",
        description: "Hisar is a dedicated legal professional with a strong background in [specific area of law, e.g., corporate law, criminal defense, family law, etc.]. With a passion for justice and over [number] years of experience. He excels in providing strategic counsel, advocating for clients' rights, and delivering successful outcomes in complex legal matters.",
        image: Profile2,
        bgColor: "#56A6A7"
    },
    {
        name: "RANDOLPH YOSUA SIAGIAN",
        title: "Partner of Sequoia Advocates",
        description: "Randolph is a dedicated legal professional with a strong background in [specific area of law, e.g., corporate law, criminal defense, family law, etc.]. With a passion for justice and over [number] years of experience. He excels in providing strategic counsel, advocating for clients' rights, and delivering successful outcomes in complex legal matters.",
        image: Profile3,
        bgColor: "#255371"
    }
]

export const OurTeam = () => {
    return (
        <Section>
            <NavigationBar />
            <Head 
                imagePath={Image}
                caption='EXPERTISE YOU TRUST FOUNDED BY THREE.'
            />
                <BGColor>
                    {data.map((user) => (
                        <Wrapper>
                            <BoxImage>
                                <ImageDiv 
                                    src={user.image} 
                                />
                                <WhiteCircle>
                                    <YellowCircle>
                                        <img src={Star} alt="star" />
                                    </YellowCircle>
                                </WhiteCircle>
                            </BoxImage>
                            <NameDivBox>
                                {user.name}
                            </NameDivBox>
                            <BodyBox backgroundColor={user.bgColor}>
                                <Title>
                                    {user.title}
                                </Title>
                                <Description>
                                    {user.description}
                                </Description>
                                <ButtonContainer>
                                    <SendEmailButton>
                                        <img 
                                            src={Email} 
                                            alt=""
                                            width="28px" 
                                            height="auto"
                                        />
                                        <Box 
                                            marginLeft='16px'
                                        >
                                            Send email
                                        </Box>
                                    </SendEmailButton>
                                    <LinkedinButton>
                                        <div>
                                            <img 
                                                src={Linkedin} 
                                                alt=""
                                                width="26px"
                                                height="auto"
                                            />
                                        </div>
                                        <Box marginLeft='16px'>
                                            Let's connect
                                        </Box>
                                    </LinkedinButton>
                                </ButtonContainer>
                            </BodyBox>
                        </Wrapper>
                    ))}
                </BGColor>
            <Footer />
        </Section>
    )
}